import { ErrorHandler, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { IAppError } from "@comunicare/comunicare-interfaces";
import { Subject } from "rxjs";
import { HealthcareserviceService } from "../../healthcareService/healthcareService.service";
import { OrganizationsService } from "../../organization/organization.service";
import { SessionService } from "../../shared/services/session.service";
import { UserService } from "../../user/user.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public catchedError = new Subject<IAppError>();

  constructor(
    private sessionService: SessionService,
    private userService: UserService,
    private healthcareService: HealthcareserviceService,
    private organizationService: OrganizationsService,
    private router: Router
  ) {}

  // tslint:disable-next-line:no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  public handleError(error: any): void {
    let appError: IAppError;

    if (error instanceof Error) {
      try {
        // essayer de parser le message si c’est un objet JSON
        appError = JSON.parse(error.message);
      } catch {
        appError = { global: false, code: 0, message: error.message };
      }
    } else {
      appError = error;
    }

    // Invalid token, disconnect and go to login page. Same in Case of error 403
    if (appError.code === 403) {
      // this.sessionService.redirectUrl = this.router.url;
      this.organizationService.clear();
      this.healthcareService.clear();
      this.userService.clear();
      this.sessionService.clear(); //
      window.location.href = "/";
    } else if (appError.code === 0 && !appError.message.startsWith("NG0100:")) {
      this.router.navigate(["dashboard"]);
    }

    this.catchedError.next(appError);
  }
}
